import { useState, useEffect } from 'react'

export interface PopupData {
  name: string
  city: string
  action: string
  time: string
  emoji: string
}

const popups: PopupData[] = [
  {
    name: 'Carlos M.',
    city: 'Houston, TX',
    action: 'acaba de comprar CERO ATRASOS',
    time: 'hace 2 minutos',
    emoji: '👷',
  },
  {
    name: 'Diego R.',
    city: 'Dallas, TX',
    action: 'agregó al carrito',
    time: 'hace 5 minutos',
    emoji: '📦',
  },
  {
    name: 'José A.',
    city: 'Chicago, IL',
    action: 'acaba de comprar CERO ATRASOS',
    time: 'hace 8 minutos',
    emoji: '🚗',
  },
  {
    name: 'Miguel S.',
    city: 'Los Ángeles, CA',
    action: 'acaba de comprar CERO ATRASOS',
    time: 'hace 11 minutos',
    emoji: '⚡',
  },
  {
    name: 'Ramón V.',
    city: 'Miami, FL',
    action: 'agregó al carrito',
    time: 'hace 3 minutos',
    emoji: '🔧',
  },
  {
    name: 'Fernando G.',
    city: 'Atlanta, GA',
    action: 'acaba de comprar CERO ATRASOS',
    time: 'hace 14 minutos',
    emoji: '🏗️',
  },
  {
    name: 'Antonio L.',
    city: 'San Antonio, TX',
    action: 'acaba de comprar CERO ATRASOS',
    time: 'hace 6 minutos',
    emoji: '🚛',
  },
  {
    name: 'Roberto M.',
    city: 'Phoenix, AZ',
    action: 'agregó al carrito',
    time: 'hace 9 minutos',
    emoji: '🔨',
  },
]

export function usePopupNotifications() {
  const [currentPopup, setCurrentPopup] = useState<PopupData | null>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    let index = 0

    const showNextPopup = () => {
      setCurrentPopup(popups[index % popups.length])
      setIsVisible(true)
      index++

      setTimeout(() => {
        setIsVisible(false)
      }, 5000)
    }

    // Initial delay of 20 seconds
    const initialTimeout = setTimeout(() => {
      showNextPopup()
      // Then every 22 seconds
      const interval = setInterval(showNextPopup, 22000)
      return () => clearInterval(interval)
    }, 20000)

    return () => clearTimeout(initialTimeout)
  }, [])

  return { currentPopup, isVisible }
}
